import { Injectable } from '@angular/core'
import { reactor } from '../reactor'
import { Subscription } from '../types'
import { customerOperations } from '../stores/customer-store'
import { SubscriptionsService } from '../services/subscriptions-service'
import { errorToast, successToast } from '../toaster'
import { paymentFailedToReactivate } from '../utils'
import { CustomersNavQueries } from 'src/modules/customers-nav/customers-nav.queries'

@Injectable({
  providedIn: 'root'
})
export class SubscriptionActions {
  subscriptionsService = new SubscriptionsService();

  constructor(private customersNavQueries: CustomersNavQueries) {}

  loadSubscription(customerId: number): void {
    this.subscriptionsService.getSubscriptionForCustomer(customerId).then((subscription) => {
      reactor.dispatch(customerOperations.setSubscription, { customerId, subscription })
    })
    .catch(() => {
      errorToast('Subscription info failed to load, please reload the page.')
    })
  }

  createSubscription(customerId: number, planCode: string, options: string[], quantity: number): Promise<any> {
    const p = this.subscriptionsService.createSubscription(customerId, planCode, options, quantity)
    p.then((subscription: Subscription) => {
      this.customersNavQueries.refetchCustomers().subscribe()
      reactor.dispatch(customerOperations.setSubscription, { customerId, subscription })
    }).catch(res => {
      const error = res.body ? res.body.message : 'Failed to set up your new plan, please try again.'
      errorToast(error, {timeOut: paymentFailedToReactivate(res) ? 0 : 8000})
    })
    return p
  }

}
